import React from 'react';
import { useNavHeightContext } from 'common/contexts/NavHeightContext';

import { NAV_HEIGHT } from '../utils/config';
import { Banners } from '../Banners';

export const DesktopPageTemplate: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;

  const { marginTop } = useNavHeightContext();

  return (
    <div>
      <div style={{ top: `${NAV_HEIGHT}px`, zIndex: 500 }} className="fixed w-screen">
        <Banners />
      </div>
      <div style={{ marginTop: `${marginTop}px` }} className="relative">
        {children}
      </div>
    </div>
  );
};
DesktopPageTemplate.displayName = 'DesktopPageTemplate';
